import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { PageGate } from "./components/PageGate";
import { router } from "./router";
import "./globals.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <PageGate>
      <RouterProvider router={router} />
    </PageGate>
  </StrictMode>,
);
